/*
 * @Description: 
 * @Author: Mankeung
 * @Date: 2021-07-07 10:03:48
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-21 10:28:14
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./utils/tools/element-use";
import axios from "axios";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

Vue.config.productionTip = false
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

import { API } from "@/utils/http/api";

import * as echarts from 'echarts';

Vue.prototype.$echarts = echarts

/* 全局判空函数引入 */
import {
    isEmpty
} from "@utils/tools/index";
/* 全局函数挂载 */
// Vue.prototype.MAINFUNC.isEmpty = isEmpty

/* 引入富文本编辑器 */
//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
//引入富文本css
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//富文本编辑器添加实例
Vue.use(VueQuillEditor, /* { default global options } */ )

router.beforeEach((to, from, next) => {
    if (to.matched.length === 0) {
        next('/error404')
    } else {
        if (!localStorage.getItem('userInfo') && to.path != "/login") {
            next('/login')
        } else {
            next()
        }
    }
});

/**
 * api请求挂载
 */
Vue.prototype.$get = API.get;
Vue.prototype.$post = API.post;
Vue.prototype.$put = API.put;
Vue.prototype.$delete = API.delete;
Vue.prototype.$axios = axios;
Vue.prototype.TaotanPermissionButtonList = []

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')